





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { optionsSymbol } from './configs';

@Component
export default class TopicBlock extends Vue {
  // state
  optionsSymbol = optionsSymbol;
  selectedOpitonsID = -1;

  @Prop({ default: '0' }) private serialNumber!: string;
  @Prop({ default: { '-1': false } }) private errorMap!: {
    [id: string]: boolean;
  };
  @Prop({ default: () => undefined }) private onChange!: (id: number) => void;
  @Prop({
    default: () => ({
      title: '标题',
      id: 0,
      options: [
        {
          id: 1,
          name: '选项1'
        },
        {
          id: 2,
          name: '选项2'
        },
        {
          id: 3,
          name: '选项3'
        },
        {
          id: 4,
          name: '选项4'
        }
      ]
    })
  })
  private data!: Topic.Data;

  // methods
  optionsHandler(id: number) {
    this.selectedOpitonsID = id;
    this.onChange(id);
  }
}
